import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import ListingSection from './ListingSection';
import ListingSectionItem from './ListingSectionItem';

const translationNoteSx = (theme) => ({
  ...theme.mixins.marketplaceSmallFontStyles,
  color: theme.tokens.matterColorAnti,
  marginTop: '12px',
  textAlign: 'right',
});

const SectionRulesMaybe = ({ rules, isTranslated, listingIsLoading }) => {
  if (listingIsLoading)
    return (
      <ListingSection>
        <ListingSectionItem>
          <Skeleton height="160px" sx={{ my: 2, borderRadius: 2 }} variant="rounded" width="100%" />
        </ListingSectionItem>
      </ListingSection>
    );

  return rules ? (
    <Grid container spacing={2}>
      <ListingSectionItem params={{ size: { lg: 12 } }}>
        <Stack width="100%">
          <Typography
            component="h3"
            mb={2}
            sx={{ textAlign: { xs: 'center', md: 'left' } }}
            variant="h4"
          >
            <FormattedMessage id="ListingPage.rulesTitle" />
          </Typography>
          <Typography sx={{ textAlign: { xs: 'left' } }} variant="body2">
            {rules}
          </Typography>
          {isTranslated ? (
            <Box component="div" sx={translationNoteSx}>
              <FormattedMessage id="ListingPage.description.translation" />
            </Box>
          ) : null}
        </Stack>
      </ListingSectionItem>
    </Grid>
  ) : null;
};

export default SectionRulesMaybe;
